// tslint:disable
export var MedicalCoverageType;
(function (MedicalCoverageType) {
    // INN
    MedicalCoverageType[MedicalCoverageType["INN"] = 1] = "INN";
    // OON
    MedicalCoverageType[MedicalCoverageType["OON"] = 2] = "OON";
    // AOB
    MedicalCoverageType[MedicalCoverageType["AOB"] = 3] = "AOB";
})(MedicalCoverageType || (MedicalCoverageType = {}));
//# sourceMappingURL=MedicalCoverageType.js.map